var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.allProjects.length === 0)?_c('NoProjects'):_c('div',{staticClass:"mb-8"},[_c('ProjectsDataIterators')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }